import passwordStrength from './passwordStrength'
import createColumns from './createColumns'

export default {passwordStrength,createColumns}